import { render, staticRenderFns } from "./BaseModalProduct.vue?vue&type=template&id=7ba4615c&scoped=true&"
import script from "./BaseModalProduct.vue?vue&type=script&lang=js&"
export * from "./BaseModalProduct.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalProduct.vue?vue&type=style&index=0&id=7ba4615c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba4615c",
  null
  
)

export default component.exports